import { format, formatRelative, parseISO } from 'date-fns'
import { de } from 'date-fns/locale'

export function formatDate(date: Date | string, formatStr = 'dd.MM.yyyy'): string {
  const d = typeof date === 'string' ? parseISO(date) : date
  return format(d, formatStr, { locale: de })
}

export function formatRelativeDate(date: Date | string): string {
  const d = typeof date === 'string' ? parseISO(date) : date
  return formatRelative(d, new Date(), { locale: de })
}

export function formatTime(date: Date | string): string {
  const d = typeof date === 'string' ? parseISO(date) : date
  return format(d, 'HH:mm')
}

export function formatDateTime(date: Date | string): string {
  return `${formatDate(date)}, ${formatTime(date)}`
}

export function formatExpiryHours(hours: number): string {
  if (hours <= 0) return '0 Min.'
  if (hours < 1) {
    const minutes = Math.round(hours * 60)
    return `${minutes} Min.`
  }
  if (Number.isInteger(hours)) return `${hours} Std.`
  const rounded = Math.round(hours * 100) / 100
  return `${rounded} Std.`
}
